var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.snapshot)?_c('ProjectValuationReport',{attrs:{"snapshot":_vm.snapshot,"report-user-input":_vm.userInput}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }